import LocalStorageImpl from '@/serviceImpl/LocalStorageImpl';

const logoutUseCase = (): void => LocalStorageImpl.removeCredentials();

export default logoutUseCase;